import { createSelector } from "reselect"
import { get, map, isEmpty } from "lodash"
import { getLastRefresh, getMetricTypeOptions, getSelectedMetricType, getSelectedSubView } from "."
import { getOrderedSecurities, getSelectedGroupName } from "./data"
import { getGrouping } from "./group"
import { getExcelValue } from "helpers/csv"
import { getTickerAndMicFromContributor } from "helpers/securities"
import { computeColumnLabel, computeFileName, getColumnValue } from "helpers/assets"
import { getPortfolioName, getViewType } from "modules/portfolio-root/selectors/portfolios"
import { getSelectedView } from "selectors/assets"
import { getColumns } from "./columns"

const FILE_PARAMS = { dataType: "Assets", isIntraday: true }
const EMPTY_ARRAY = []

export const getDownloadButtonTooltip = createSelector(
  [getGrouping, getSelectedGroupName],
  (grouping, selectedGroupName) => {
    if (selectedGroupName) {
      return "Download Group Contributors"
    }
    if (grouping) {
      return "Download Groups"
    }
    return "Download Contributors"
  },
)

const getFileName = createSelector(
  [getPortfolioName, getGrouping, getSelectedGroupName, getViewType, getLastRefresh, getSelectedView, getSelectedMetricType, getSelectedSubView, getMetricTypeOptions, () => FILE_PARAMS],
  computeFileName,
)

export const getDownloadData = createSelector(
  [getOrderedSecurities, getFileName, getGrouping, getSelectedGroupName, getColumns, getSelectedView],
  (securities, fileName, grouping, selectedGroupName, columns, selectedView) => {
    const shouldIncludeSecurityMetadata = !grouping || (grouping && selectedGroupName)
    const groupingLabel = get(grouping, "label", "")

    const cols = [
      (!shouldIncludeSecurityMetadata && groupingLabel) || "Identifier",
      ...(shouldIncludeSecurityMetadata ? ["MIC", "Bloomberg Ticker", "Country", "Asset Class", "Currency", "Industry"] : []),
      ...map(columns, column => computeColumnLabel(column, selectedView, false)),
      ...(selectedGroupName ? ["Selected Group"] : []),
    ]

    return {
      fileName,
      type: FILE_PARAMS.dataType,
      data: isEmpty(securities) ? EMPTY_ARRAY : [
        cols,
        ...map(securities, security => {
          const { mic: exchange } = getTickerAndMicFromContributor(security)
          const { ticker, description, id, label, bloombergTicker, country, assetClass, currency, classification } = security
          return [
            ticker || description || id || label,
            ...(shouldIncludeSecurityMetadata ? [exchange, bloombergTicker, country, assetClass, currency, get(classification, "name")] : []),
            ...map(columns, column => getExcelValue(getColumnValue(security, column), { percent: column.outputFormat === "percent" })),

            ...(selectedGroupName ? [selectedGroupName] : []),
          ]
        }),
      ],
    }
  },
)
